/**
 * Live TV page: video poster visibility and Last 24 tabs.
 * Expects block root to have data-live-tv-page-id and data-last-24-tabs-id.
 */
(function() {
  function run() {
    var coaBlock = document.querySelector('[data-live-tv-page-id]');
    var tabsBlock = document.querySelector('[data-last-24-tabs-id]');
    if (!coaBlock && !tabsBlock) return;

    var sectionId = coaBlock ? coaBlock.getAttribute('data-live-tv-page-id') : null;
    var last24Id = tabsBlock ? tabsBlock.getAttribute('data-last-24-tabs-id') : null;
    var section = sectionId ? document.getElementById(sectionId) : null;
    var tabsRoot = last24Id ? document.getElementById(last24Id) : null;

    if (section) {
      var wrap = section.querySelector('[data-live-tv-player]');
      var video = section.querySelector('.live-tv-page__video');
      var poster = section.querySelector('[data-poster-overlay]');
      var posterPlay = section.querySelector('[data-poster-play]');
      function updatePosterVisibility() {
        if (!poster || !video) return;
        var show = video.paused || video.readyState < 2;
        poster.classList.toggle('is-visible', show);
        poster.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      function playVideo() {
        if (!video) return;
        video.muted = true;
        video.play().catch(function() {});
      }
      if (video) {
        video.addEventListener('play', updatePosterVisibility);
        video.addEventListener('pause', updatePosterVisibility);
        video.addEventListener('waiting', updatePosterVisibility);
        video.addEventListener('canplay', updatePosterVisibility);
        video.addEventListener('loadeddata', updatePosterVisibility);
        if (poster) poster.classList.add('is-visible');
      }
      if (posterPlay && video) {
        posterPlay.addEventListener('click', playVideo);
        posterPlay.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playVideo(); }
        });
      }
      updatePosterVisibility();
    }

    if (tabsRoot) {
      var tabs = tabsRoot.querySelectorAll('.last-24-tabs__tab');
      var panels = tabsRoot.querySelectorAll('.last-24-tabs__panel');
      function selectTab(index) {
        tabs.forEach(function(t, i) {
          var selected = i === index;
          t.setAttribute('aria-selected', selected);
          t.classList.toggle('last-24-tabs__tab--selected', selected);
        });
        panels.forEach(function(p, i) {
          var selected = i === index;
          p.hidden = !selected;
          p.classList.toggle('is-selected', selected);
        });
      }
      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() { selectTab(index); });
        tab.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); selectTab((index + 1) % tabs.length); tabs[(index + 1) % tabs.length].focus(); }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); selectTab((index - 1 + tabs.length) % tabs.length); tabs[(index - 1 + tabs.length) % tabs.length].focus(); }
          else if (e.key === 'Home') { e.preventDefault(); selectTab(0); tabs[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); selectTab(tabs.length - 1); tabs[tabs.length - 1].focus(); }
        });
      });

      // Deep links from the homepage quick-nav tiles:
      //   #tab-hours     → Last 24 Hours
      //   #tab-best-buys → Best Buys
      // View All uses #rap_section, which the browser scrolls to on its own and
      // leaves the default Last 24 Items tab selected.
      // A URL can only carry one hash, and these tab hashes are not element ids
      // (the buttons are last-24-tabs-{block}-tab-*). Click the tab so
      // ltv-app.js still lazy-loads the panel, then scroll #rap_section the
      // same way View All does. Keep the tab hash so a refresh reopens it.
      var rapAlignTimer = 0;
      var rapAlignUntil = 0;
      var rapAlignCancelled = false;

      function cancelRapAlign() {
        rapAlignCancelled = true;
        rapAlignUntil = 0;
        if (rapAlignTimer) {
          window.clearInterval(rapAlignTimer);
          rapAlignTimer = 0;
        }
      }

      function alignRapSection() {
        if (rapAlignCancelled) return;
        var section = document.getElementById('rap_section');
        if (!section) return;
        var top = window.scrollY + section.getBoundingClientRect().top;
        if (Math.abs(window.scrollY - top) <= 2) return;
        window.scrollTo(0, top);
      }

      function scheduleRapAlign() {
        cancelRapAlign();
        rapAlignCancelled = false;
        rapAlignUntil = Date.now() + 1600;
        alignRapSection();
        window.requestAnimationFrame(alignRapSection);
        rapAlignTimer = window.setInterval(function() {
          if (rapAlignCancelled || Date.now() > rapAlignUntil) {
            if (rapAlignTimer) {
              window.clearInterval(rapAlignTimer);
              rapAlignTimer = 0;
            }
            return;
          }
          alignRapSection();
        }, 150);
      }

      function tabFromHash() {
        var hashMatch = (window.location.hash || '').match(/^#tab-(.+)$/);
        if (!hashMatch) return null;
        for (var ti = 0; ti < tabs.length; ti++) {
          if (tabs[ti].getAttribute('data-tab') === hashMatch[1]) return tabs[ti];
        }
        return null;
      }

      function applyTabHash() {
        var deepLinkTab = tabFromHash();
        if (!deepLinkTab) return false;
        // click() (not selectTab) so the Hours/Best Buys lazy-load listener fires.
        if (deepLinkTab.getAttribute('aria-selected') !== 'true') {
          deepLinkTab.click();
        }
        scheduleRapAlign();
        return true;
      }

      if (!applyTabHash()) {
        selectTab(0);
      }

      window.addEventListener('hashchange', function() {
        if (!applyTabHash()) cancelRapAlign();
      });
      window.addEventListener('wheel', cancelRapAlign, { passive: true });
      window.addEventListener('touchmove', cancelRapAlign, { passive: true });
      window.addEventListener('load', function() {
        if (!rapAlignCancelled && tabFromHash()) alignRapSection();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
